import { useMutation } from '@apollo/client';
import React from 'react';

import { MANUAL_RENT_PAYMENT_UPDATE } from '../../../../graphql/admin_mutations';
import ImageModalComp from '../../../../components/ImageModalComp';
import useForm from '../../../../customHooks/useForm';
import useToast from '../../../../customHooks/useToast';

type Props = {
  closeModal:any;
  docName: string;
  rentPaymentId: string;
  refetch: any;
  permissionName?: string;
}

const MarkRentAsPaidComp = ({
  closeModal, docName, refetch, rentPaymentId, permissionName,
}: Props) => {
  const [manualRentPaymentUpdate] = useMutation<
  { manualRentPaymentUpdate: any },
   any
>(MANUAL_RENT_PAYMENT_UPDATE);

  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState<any>(null);
  const { formValues, handleChange } = useForm({
    documentType: docName,
    documentId: '',
  });
  const Toast = useToast();
  const handleSubmit = async () => {
    if (!uploadFile) {
      Toast.error('Please select a file to upload');
      return;
    }
    setUploadLoading(true);
    try {
      const variables = {
        file: uploadFile,
        id: rentPaymentId,
      };

      const res = await manualRentPaymentUpdate({
        variables,
      });

      if (res?.data) {
        const message = res?.data?.manualRentPaymentUpdate?.message;
        const status = res?.data?.manualRentPaymentUpdate?.status;

        if (status === 200) {
          Toast.success(message);
          refetch?.();
          closeModal(false);
          setUploadFile(null);
        } else {
          Toast.error(message);
        }
      }
    } catch (e) {
      if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
        Toast.error(e.graphQLErrors[0].message);
      } else {
        Toast.error('Something went wrong');
      }
    }
    setUploadLoading(false);
  };

  return (
    <ImageModalComp
      closeModal={closeModal}
      title="Proof of Payment"
      text="Upload proof of payment"
      uploadFile={uploadFile}
      setUploadFile={setUploadFile}
      viewOnly
      value={formValues?.documentType}
      handleChange={handleChange}
      uploadLoading={uploadLoading}
      onSubmit={handleSubmit}
      permissionName={permissionName}
    />
  );
};

export default MarkRentAsPaidComp;
